var _path, _path2, _path3, _ellipse, _path4, _rect, _path5, _rect2, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.285156 1.01617C0.285156 0.537475 0.673219 0.149414 1.15192 0.149414H47.0225C47.5012 0.149414 47.8893 0.537476 47.8893 1.01618V42.3531C47.8893 42.8317 47.5012 43.2198 47.0225 43.2198H1.15192C0.673217 43.2198 0.285156 42.8317 0.285156 42.3531V1.01617Z",
    fill: "#C798FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76465 28.4453V14.4576C9.76465 12.903 11.7233 12.2159 12.6934 13.4301L22.2161 25.3319L9.76465 28.4453Z",
    fill: "#EFB32E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6802 28.4453V14.4576C39.6802 12.903 37.7215 12.2159 36.7493 13.4301L27.2266 25.3319L39.6802 28.4453Z",
    fill: "#EFB32E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.4696,
    cy: 34.0977,
    rx: 16.8915,
    ry: 3.49224,
    fill: "#D39D18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3164 24.0661L22.91 8.13004C23.8083 6.75997 25.8428 6.84408 26.6263 8.28385L33.456 23.6908L14.3164 24.0661Z",
    fill: "#FFC533"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.1074,
    y: 23.3496,
    width: 6.19184,
    height: 6.19184,
    transform: "rotate(45 26.1074 23.3496)",
    fill: "#D39D18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2943 12.7793L19.916 17.1576L24.2943 21.5359V12.7793Z",
    fill: "#D39D18"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8242,
    y: 22.0293,
    width: 5.22377,
    height: 5.22377,
    transform: "rotate(45 25.8242 22.0293)",
    fill: "#FF859A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2944 13.1113L20.6006 16.8051L24.2944 20.4989V13.1113Z",
    fill: "#FF556A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66211 25.9139C9.66211 25.9139 21.65 17.8864 39.5815 25.6022L9.66211 25.9139Z",
    fill: "#D39D18"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7519 34.9405L36.2899 34.0072C28.726 31.9666 20.7601 31.946 13.1838 33.9437L9.35461 34.9527C8.41107 35.203 7.48828 34.4913 7.48828 33.515V27.4893C7.48828 26.8125 7.94342 26.2218 8.5957 26.0495L13.1838 24.8394C20.7601 22.8418 28.726 22.8643 36.2899 24.903L40.5252 26.0454C41.1754 26.2197 41.6266 26.8084 41.6266 27.4811V33.5027C41.6266 34.4831 40.6975 35.1948 39.7519 34.9405Z",
    fill: "#F9BF1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4483 15.2305C39.4483 15.2305 39.3314 18.1326 37.707 18.1326C37.707 18.1326 39.6226 18.6556 39.6226 20.3969C39.6226 20.3969 40.1437 18.1326 41.3064 18.1326C41.3064 18.1326 39.4483 18.2495 39.4483 15.2305Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2374 21.5254C13.2374 21.5254 13.1224 24.4275 11.4961 24.4275C11.4961 24.4275 13.4117 24.9505 13.4117 26.6918C13.4117 26.6918 13.9347 24.4275 15.0956 24.4275C15.0956 24.4275 13.2374 24.5444 13.2374 21.5254Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.801 9.79102C29.801 9.79102 29.6636 13.212 27.748 13.212C27.748 13.212 30.006 13.8273 30.006 15.8804C30.006 15.8804 30.6215 13.212 31.9915 13.212C31.9915 13.212 29.801 13.3474 29.801 9.79102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKing);
export default __webpack_public_path__ + "static/media/king.406ad60b3de4dad5fa2c1e7fe337a42f.svg";
export { ForwardRef as ReactComponent };